var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDraggable',{attrs:{"is-active":_vm.isActive,"hands":_vm.hands},on:{"select":_vm.handleResult}})}
var staticRenderFns = []

export { render, staticRenderFns }